module.exports = __webpack_public_path__ + "img/small.1fcc37d9.svg";